import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { IComplex } from 'src/typings/complexes';
import { borderColor } from 'src/constants/styles';

export const ComplexImages: React.FC<{complex: IComplex}> = ({ complex }) => {
  const [preview] = useState(complex.previewFileUri?.fileUrl);

  return (
    <Box
      border={`1px solid ${borderColor}`}
      borderRadius="8px"
      overflow="hidden"
      width="100%"
      height="100%"
    >
      <Box
        width="100%"
        height="444px"
        position="relative"
        style={{
          backgroundImage: `url(${preview})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      />
      <Box
        display="flex"
        alignItems="center"
        flexWrap="nowrap"
      />
    </Box>
  );
};
